import siteData from '../../data/site.json'

export default function GalleryFilters({ selectedCategory, onCategoryChange }) {
  return (
    <div className="flex flex-wrap justify-center gap-3 mb-12">
      {siteData.galleryCategories.map(category => (
        <button
          key={category.id}
          onClick={() => onCategoryChange(category.id)}
          className={`px-6 py-2 rounded-full font-medium transition-all duration-300 ${
            selectedCategory === category.id
              ? 'bg-primary text-white shadow-md scale-105'
              : 'bg-white text-neutral-700 hover:bg-neutral-100 border border-neutral-300 hover:border-primary/50'
          }`}
          aria-pressed={selectedCategory === category.id}
        >
          {category.label}
        </button>
      ))}
    </div>
  )
}
